export class ModificationDescription {
  private key: string;
  private params!: Record<string, any>;

  constructor(key: string) {
    this.key = key;
  }

  withParams(params: Record<string, any>): ModificationDescription {
    this.params = params;
    return this;
  }

  getValue(): {key: string; params: Record<string, any>} {
    return {
      key: this.key,
      params: this.params,
    };
  }
}
